/* global Swiper */
// *******************************************************************************
// 1.0 - Image Gallery Slider
// *******************************************************************************

const imageGalleryMainSliderEle = document.querySelectorAll('[data-slider="image-gallery-main"]');
const imageGalleryThumbSliderEle = document.querySelectorAll('[data-slider="image-gallery-thumb"]');

// *******************************************************************************
// 1.1 - Image Gallery Thumb Slider
// *******************************************************************************

const imageGalleryThumbSliderOptions = {
  slidesPerView: 3,
  spaceBetween: 20,
  speed: 300,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
    1240: {
      slidesPerView: 6,
      spaceBetween: 24,
    },
  },
};

imageGalleryThumbSliderEle.forEach((el) => new Swiper(el, imageGalleryThumbSliderOptions));

// *******************************************************************************
// 1.2 -Image Gallery Main Slider
// *******************************************************************************

const imageGalleryMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 300,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  thumbs: {
    swiper: false,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
    renderFraction(currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span>/</span><span class="${totalClass}"></span><span></span>`;
    },
  },
};

imageGalleryMainSliderEle.forEach((el, i) => {
  const imageGalleryMainParent = el.closest('.image-gallery');
  const arrowRight = imageGalleryMainParent.querySelector('.arrow-right');
  const arrowLeft = imageGalleryMainParent.querySelector('.arrow-left');

  imageGalleryMainSliderOptions.navigation.nextEl = arrowRight;
  imageGalleryMainSliderOptions.navigation.prevEl = arrowLeft;
  imageGalleryMainSliderOptions.thumbs.swiper = imageGalleryThumbSliderEle[i].swiper;

  // eslint-disable-next-line no-new
  new Swiper(el, imageGalleryMainSliderOptions);
});
